import React, { FunctionComponent, useEffect } from 'react';
import { ProductTeaserContent } from '../../services/marketingContent.service';
import { Button, Chip, Snackbar } from 'shamrock-clover-ui';
import { FederatedModules, ProductRequests } from '../../types';
import css from './styles/productTeaserView.scss';
import FirebaseAnalytics from './analytics';
import { useSelector } from 'react-redux';
import { RootState } from '../../bootstrap';
import { getProductRequests, getTrialState } from '../../redux/selectors/selectors';
import checkCircleBlue from '../../assets/images/checkCircleBlue.svg';
import { useTranslation } from 'react-i18next';

interface ProductTeaserViewProps {
  handleAskAbout: () => void;
  product: FederatedModules;
  productTeaser: ProductTeaserContent;
  logFirebaseEvent: (module: string, page: string, description: string) => void;
  firebasePages: Record<string, string>;
}

export const ProductTeaserView: FunctionComponent<ProductTeaserViewProps> = ({
  handleAskAbout,
  product,
  productTeaser,
  logFirebaseEvent,
  firebasePages,
}) => {
  const productRequests = useSelector((state: RootState) => getProductRequests(state));
  const { isTrial, isRegistered } = getTrialState();
  const isFreight = product === 'Freight';
  const isUnmatched = isTrial && isRegistered;
  useEffect(() => {
    window.addEventListener('popstate', () =>
      logFirebaseEvent(FirebaseAnalytics.MODULES.PRODUCT_TEASERS, firebasePages[product], `exit ${product}`),
    );
  }, []);
  const { t } = useTranslation();

  const infoRequested = productRequests?.includes(ProductRequests[product]);

  return (
    <div className={css.productTeaser}>
      <div className={css.productTeaserCard}>
        <div className={css.productTeaserContent}>
          <div className={css.productTeaserBody}>
            <h2 className={css.productTeaserTitle}>{product}</h2>
            <p className={css.productTeaserAccessMessage}>{t('you_dont_currently_have_access_to_this_feature')}</p>
            {productTeaser.infoCards.map((card) => (
              <div key={card.body} className={css.infoCard}>
                <div className={css.infoCardIcon}>
                  <img src={`data:image/svg+xml;base64,${card.icon}`} />
                </div>
                <div className={css.infoCardBody}>
                  {card.title && <span className={css.infoCardBodyTitle}>{card.title}</span>}
                  <p className={css.infoCardBodyText}>{card.body}</p>
                </div>
              </div>
            ))}
          </div>
          {(!isUnmatched || isFreight) &&
            (infoRequested ? (
              <div className={css.reviewChip}>
                <Chip
                  leftIcon={<img src={checkCircleBlue} style={{ paddingRight: '13px' }} />}
                  backgroundColor="#EAF7FF"
                  variant="base"
                  state="enabled"
                  label={t('our_team_is_currently_reviewing_your_inquiry')}
                />
              </div>
            ) : (
              <div className={css.productTeaserButton}>
                <Button onClick={handleAskAbout}>{productTeaser.buttonText}</Button>
              </div>
            ))}
        </div>
        <div className={css.productTeaserImage}>
          <img src={productTeaser.headerImage} className={css.productTeaserImage} />
        </div>
      </div>
      <Snackbar
        open={isUnmatched && !isFreight}
        position="bottomCenter"
        duration={5000000}
        message={t('to_start_using_rtspro_your_company_must_add_you_as_user')}
        variant="error"
      />
    </div>
  );
};
